var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10.158 1.493-8.617 8.603a.6.6 0 0 0-.167.381l.354 3.961c0 .148.056.287.167.391a.56.56 0 0 0 .39.146h.01l3.839.381a.54.54 0 0 0 .389-.146l8.691-8.677a.563.563 0 0 0 0-.787l-4.267-4.26a.574.574 0 0 0-.789.007M6.049 14.527l-3.591-.293-.232-3.698L8.225 4.57l3.897 3.917zm6.539-6.504L8.699 4.105l1.818-1.972 4.059 3.93z"
  })));
};
export default SvgEdit;